import { Radio } from 'antd';
import styled from 'styled-components';

export const CustomRadioGroup = styled(Radio.Group)`
	display: flex;
	flex-direction: column;
	gap: 1rem;
`;
